/* global axios */
import ApiClient from '../ApiClient';

class ElectoralCampaignEventsAPI extends ApiClient {
  constructor() {
    super('electoral_campaign/events', {
      accountScoped: true,
      apiVersion: 'v2',
    });
  }

  list({ eventType, from, to } = {}) {
    const params = {};
    if (eventType) params.eventType = eventType;
    if (from) params.from = from;
    if (to) params.to = to;
    return axios.get(this.url, { params });
  }

  create(payload) {
    return axios.post(this.url, payload);
  }

  update(id, payload) {
    return axios.patch(`${this.url}/${id}`, payload);
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }
}

export default new ElectoralCampaignEventsAPI();
